import React from "react"
import { Link } from 'react-router-dom';
import "../../styles/LoginForm.css";
import LoginContainer from "../containers/LoginContainer";
import LoginFooter from "./LoginFooter";
import { Icon } from "@vitalsource/vstui";
import externalTabIcon from "../../img/new-external-tab.svg";
import {Calendar, XSmall} from "@vitalsource/vstui-icons";
import Styled from "styled-components"
import { connect } from "react-redux";
import { setTargetUrl } from "../actions/login";

const CustomXSmall = Styled(XSmall)`
  pointer-events: none;
`;

export interface LoginFormProps {
}

const mapDispatchToProps = (dispatch: any) => ({
  setTargetUrl: (targetUrl: string) => dispatch(setTargetUrl(targetUrl))
});

const LoginForm = (props: LoginFormProps & { setTargetUrl: (targetUrl: string) => void }) => {
  React.useEffect(() => {
    // Check sessionStorage for deep linking path
    const storedPath = sessionStorage.getItem('intendedPath');
    
    if (storedPath && storedPath !== 'login' && storedPath !== '/not-found') {
      props.setTargetUrl(storedPath);
      sessionStorage.removeItem('intendedPath');
    }
  }, [props.setTargetUrl]);

  return (
    <div className={"login"}>
      <div className={"login__layout"}>
        <LoginContainer />
        <LoginFooter />
      </div>
    </div>
  )
}

export default connect(null, mapDispatchToProps)(LoginForm);
